import React from 'react';
import { Link } from 'react-router-dom';
import './PulsePage.css'; // We'll create this CSS file

export interface ServicesGroup {
  id: string;
  name: string;
  description?: string;
}

interface ServicesGroupSelectorProps {
  customerName: string;
  segments: ServicesGroup[];
  currentUrl: string; // e.g., /pulse
}

const ServicesGroupSelector: React.FC<ServicesGroupSelectorProps> = ({
  customerName,
  segments,
  currentUrl,
}) => {
  return (
    <div className="view-segment-selector-container">
      <h2>Select a View for {customerName}</h2>
      <p>Please choose a services group to explore the pulse data.</p>
      <div className="view-segment-list">
        {segments.map(segment => (
          <Link
            key={segment.id}
            to={`${currentUrl}?view=${encodeURIComponent(segment.id)}`}
            className="view-segment-card deriq-action-button" // Reusing your action button style
          >
            <h3>{segment.name}</h3>
            {segment.description && <p>{segment.description}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ServicesGroupSelector;